import React from 'react'
import { Link } from '@inertiajs/react'
import {
  Paper,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  IconButton,
} from '@mui/material'
import {
  Add as AddIcon,
  Visibility as VisibilityIcon,
} from '@mui/icons-material'
import ManagementLayout from '@/components/layouts/ManagementLayout'
import EmptyState from '@/components/shared/EmptyState'
import { PageHeader } from '@/components/styled'
import type { Account } from '@/types'

interface Props {
  accounts: Account[]
}

export default function AccountsIndex({ accounts }: Props) {
  return (
    <ManagementLayout>
      <PageHeader
        title="Accounts"
        description="Manage your accounts and organizations."
        action={
          <Button component={Link} href="/accounts/new" variant="contained" startIcon={<AddIcon />}>
            Create Account
          </Button>
        }
      />

      {accounts.length > 0 ? (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Role</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {accounts.map((account) => (
                <TableRow key={account.id} hover>
                  <TableCell>
                    <Link href={`/accounts/${account.slug}/dashboard`}>{account.name}</Link>
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={account.role === 'admin' ? 'Admin' : 'Member'}
                      size="small"
                      color={account.role === 'admin' ? 'primary' : 'default'}
                    />
                  </TableCell>
                  <TableCell align="right">
                    <IconButton
                      component={Link}
                      href={`/accounts/${account.slug}/dashboard`}
                      size="small"
                    >
                      <VisibilityIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <EmptyState
          icon="inbox"
          title="No accounts"
          description="Create your first account to get started."
          actionPath="/accounts/new"
          actionText="Create Account"
        />
      )}
    </ManagementLayout>
  )
}
